import React from "react";

/**
 * ExportLoader - Modal overlay with spinner shown during heavy Excel / PDF report generation.
 * @param {string|null} message - Text to display (e.g. "Generating Excel...", "Generating PDF...")
 */
export default function ExportLoader({ message }) {
  if (!message) return null;
  const label = typeof message === "string" ? message : "Generating File...";

  return (
    <div className="fixed inset-0 z-[99999] flex items-center justify-center bg-slate-900/40 backdrop-blur-[2px] transition-all duration-200">
      <div className="bg-white rounded-xl shadow-2xl border border-slate-200 px-6 py-5 flex items-center gap-4 max-w-sm w-full mx-4 animate-in fade-in zoom-in-95 duration-150">
        <div className="relative shrink-0 flex items-center justify-center w-11 h-11 rounded-full bg-blue-50 border border-blue-100">
          <div className="w-6 h-6 border-[3px] border-blue-600 border-t-transparent rounded-full animate-spin" />
        </div>
        <div className="flex flex-col min-w-0">
          <span className="font-['Inter'] text-[14px] font-bold text-slate-800 truncate">
            {label}
          </span>
          <span className="font-['Inter'] text-[11px] text-slate-500 font-medium">
            Please wait while processing records...
          </span>
        </div>
      </div>
    </div>
  );
}
